export const frontmatter = {
    "draft": true,
    "title": "Examples",
    "description": "Usage examples for the OnnIA API.",
    "sidebar_label": "Examples",
    "sidebar_group": "reference",
    "sidebar_order": 4
}

export const toc = []